import { render } from "./TopContentUploaders.vue?vue&type=template&id=c255e81a"
import script from "./TopContentUploaders.vue?vue&type=script&lang=js"
export * from "./TopContentUploaders.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/v3-stage.teachers.gov.bd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__